define("SDB.Locations.Finance.View", [
  "PageType.Base.View",
  "sdb_locations_finance.tpl",
  "SDB.SDBLocations.Model",
  "SDB.SDBLocations.Modal.View",
  "SDB.Locations.Finance.Modal.View",
  "Backbone",
], function (
  PageType,
  locationsfinance_tpl,
  SDBSDBLocationsModel,
  SDBLocationsModalView,
  SDBLocationsFinanceModalView,
  Backbone
) {
  "use strict";
  var previousView;
  return Backbone.View.extend({
    template: locationsfinance_tpl,

    initialize: function initialize(options) {
      if (previousView) {
        previousView.destroy();
        previousView = undefined;
      }
      previousView = this;

      var self = this;
      this.title = "Financing";
      this.options = options || {};
      this.shoppingOnlineSet = false;
      this.env = SC.Application.getComponent("Environment");
      this._configLocations = this.env.getConfig("SDBLocations.Locations");
      this.model = SDBSDBLocationsModel.getInstance();
      this.locations = this.model.getLocations();
      this.updateFrameData();
      self.getBreadcrumbPages();
      this.model.on(
        "change:location",
        function () {
          var shoppingExperience = self.model.get("shoppingExperience");

          if (shoppingExperience !== "online") {
            self.updateFrameData();
            self.render();
          }
        },
        this
      );

      SDBLocationsModalView.prototype.closeModal = _.wrap(
        SDBLocationsModalView.prototype.closeModal,
        function (fn) {
          fn.apply(this, _.toArray(arguments).slice(1));
          if (
            !self.shoppingOnlineSet &&
            (this.model.getShoppingExperience() === "online" ||
              !this.model.getSelectedLocation()) &&
            Backbone.history.fragment.indexOf("finance") != -1 &&
            previousView.cid == self.cid
          ) {
            self.shoppingOnlineSet = true;
            // window.alert('Sorry, we do not offer financing for online shopping yet.');
            // self.redirectToHome();
            var noLocationModalView = new SDBLocationsFinanceModalView({
              container: self.container,
              view: self,
            });
            self
              .getLayout()
              .showContent(noLocationModalView, { showInModal: true });
          }
        }
      );
    },
    getLayout: function getLayout() {
      return this.options.container.getComponent("Layout");
    },

    getBreadcrumbPages: function getBreadcrumbPages() {
      var self = this;
      var breadcrumbPages = [
        {
          text: "Financing",
          href: "#/finance",
        },
      ];

      return breadcrumbPages;
    },
    showLocationsModal: function showLocationsModal(container) {
      var modalView = new SDBLocationsModalView({
        container: container,
        view: this,
        pageHeader: "Select Your Shopping Experience",
        locations: this.locations,
      });
      this.getLayout().showContent(modalView, { showInModal: true });
    },
    updateFrameData: function updateFrameData() {
      var selectedLocation = this.model.getSelectedLocation();

      var locationConfig = _.find(this._configLocations, function (location) {
        if (selectedLocation) {
          return location.id === selectedLocation.internalid;
        } else {
          return false;
        }
      });

      if (locationConfig) {
        this.frameURL = this.env.getConfig("SDBLocations.config");
        this.key = locationConfig.key;
      } else {
        this.frameURL = this.env.getConfig("SDBLocations.config");
        this.key = undefined;
        // var button = document.querySelector('.financing-section-container button');

        // console.log(button);

        // if (button) {
        //     button.style.display = 'none';
        // }
      }
    },
    redirectToHome: function redirectToHome() {
      Backbone.history.navigate("/", { trigger: true });
    },
    getContext: function getContext() {
      this.container = this.options.container;
      if (
        this.model.getShoppingExperience() === "online" ||
        !this.model.getSelectedLocation()
      ) {
        this.showLocationsModal(this.container);
      }
      return {
        frameUrl: this.frameURL,
        key: this.key,
      };
    },
  });
});
